import $ from "jquery";
import { config } from '../config/config'

const utils = (() => {

    // 
    const getCode = (code) => {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: config('http') + 'code/' + code,
                type: 'get',
                dataType: 'text',
                success: function(data) { resolve(data) },
                error: function(xhr, errorType, error) {
                    reject('code request error, errorType: ' + errorType + ', error: ' + error)
                }
            });
        });
    }

    return { getCode: getCode };
})()

export default utils;